<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { mapState } from "vuex";
import { getInfo, testToken } from "./request/business.js";
import Cookies from "js-cookie";
import eventBus from "@/utils/eventBus";
import { EventBus } from "@/utils/event-bus";
import mqtt from "mqtt";

export default {
  computed: {
    ...mapState({
      user_info: (state) => state.userData
    })
  },
  data() {
    return {
      userID: "",
      userInfo:{},
      watchDog: null
    };
  },
  beforeCreate() {

    window.addEventListener("beforeunload", async () => {
      //在页面刷新时将vuex里的信息保存到sessionStorage里
      if (Cookies.get("private-Token")) {
        sessionStorage.setItem("state", JSON.stringify(this.$store.state));
      }
      eventBus.$offAll();
      EventBus.$offAll();
      this.closeWs();
      await this.localSocket();
    });
  },
  beforeDestroy() {
    eventBus.$offAll();
    EventBus.$offAll();
  },
  created() {
    eventBus.$on("openWebsocket", () => {
      this.init();
      let cook = Cookies.get("private-Token");
      if (cook) {
        this.init();
        this.localSocket();
      }
    });
    EventBus.$on("DESTROY_WS", () => {

      this.closeWs();
    });
    let cook = Cookies.get("private-Token");
    if (cook) {
      this.init();
      this.localSocket();
    }
  },
  methods: {
    init() {
      //在页面加载时读取sessionStorage里的状态信息
      if (sessionStorage.getItem("state")) {
        this.$store.replaceState(
          Object.assign(
            {},
            this.$store.state,
            JSON.parse(sessionStorage.getItem("state"))
          )
        );
      }
    },
    onmessage(topic, message) {
      try {
        var events = JSON.parse(message);
      } catch (e) {
        return;
      }
      var that = this;
      if (events.type === "soloLogin") {
        this.$store.dispatch("FedLogOut");
        this.closeWs();
        this.$confirm(events.content, "Tips", {
          confirmButtonText: "OK",
          type: "warning",
          showCancelButton: false
        }).then(() => {
          this.$router.push("/login");
        }).catch(() => {

        });
        // var newEvent = JSON.parse(JSON.stringify(event))
      } else {
        testToken().then((response) => {
          if (response.success) {
            var ststus = events.notification.title;
            eventBus.$emit("websocket", true);
            that.$notify({
              title: "Tips",
              dangerouslyUseHTMLString: true,
              message: `<p>You have a message about ${ststus}, please check it in time!</p>`,
              type: "success",
              duration: 5000
            });
            EventBus.$emit("REFRESH_NOTIFICATION_NUM");
          } else {
            this.$message.error(response.message);
          }
        });
      }
    },
    async localSocket() {
      this.userInfo = this.$store.state.user
      await getInfo().then((res) => {
        if (res.success) {
          this.userInfo = res.user
          this.userID = res.user.userId;
          localStorage.setItem("userId", res.user.userId);
        }
      });
      if ("WebSocket" in window) {
        this.closeWs()
        this.ws = mqtt.connect(`${process.env.VUE_APP_WS_ADDR}`, {
          username: this.userInfo.userName,
          password: this.$store.state.user.token,
          clientId: "st-server-front_" + this.userID + "_" + new Date().getTime() + "_" + Math.ceil(Math.random() * 1000),
          keepalive: 60,
          protocolId: 'MQTT',
          protocolVersion: 4,
          clean: true,
          reconnectPeriod: 1000,
          connectTimeout: 30 * 1000
        });
        this.$global.setWs(this.ws);
        let _this = this;
        this.ws.on('connect', function () {
          _this.ws.subscribe([`${_this.userID}`], (err) => {
            if (_this.ws.connected) {
              _this.watchDog = setInterval(()=> {
                if (_this.ws.disconnected) {
                  _this.ws.end(true)
                  _this.localSocket()
                }
              }, 10000)
            }
          });
        });
        this.ws.on("message", function (topic, message) {
          _this.onmessage(topic, message)
        });
        this.ws.on("close", function () {
          _this.ws.end()
        })
        this.ws.on("error", function () {

         // _this.ws.reconnect()
        })

      } else {
        // 浏览器不支持 WebSocket
        this.$message.warning("The browser you are using does not support WebSocket, and you will not receive messages in time！")
      }
    },
    closeWs() {
      if (this.ws) {
        this.ws.end();
      }
      // 销毁定时器
      if (this.watchDog != null) {
        clearInterval(this.watchDog);
      }
    }
  },
  destroyed() {
    this.closeWs();
  }
};
</script>
<style lang="scss">
body,
html {
  overflow-y: hidden !important;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  // background: #f2f3f8;
  height: 100%;
  // min-width: 1920px;
}

* {
  padding: 0;
  margin: 0;
}
.element::-webkit-scrollbar {display:none}
.ivu-card-head {
  font-weight: 700;
}

.el-popover {
  padding: 0px !important;
}

.popOne > .el-popover {
  min-height: 400px;
}

.el-table__body {
  width: 100%;
  // 使表格兼容safari，不错位
  table-layout: fixed !important;
}

.el-table__fixed-right::before, .el-table__fixed::before {
  display: none;
}
//修改全局el-table高度
//.el-table--enable-row-transition .el-table__body td.el-table__cell{
//  height: 93px !important;
//}
//.el-table--scrollable-x .el-table__body-wrapper {
//  z-index: 1;
//}
/*css主要部分的样式*/
/*定义滚动条宽高及背景，宽高分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  border-radius: 10px;
}

/*定义滑块颜色、内阴影及圆角*/
::-webkit-scrollbar-thumb{
  background-color: #DDDEE0;
  border-radius: 10px;
}

/*定义滑块悬停变化颜色、内阴影及圆角*/
::-webkit-scrollbar-thumb:hover{
  background-color: #C7C9CC;
  border-radius: 10px;
}
::-webkit-scrollbar-corner{
  border-radius: 10px;
}

::v-deep .el-tooltip__popper{
  white-space: pre !important;
}
</style>
